// import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  AfterViewInit,
  Input
} from '@angular/core';
import {
  Chart
} from "angular-highcharts";
import * as Highcharts from "highcharts";
declare var require: any;
require("highcharts/highcharts-more")(Highcharts);
import {
  StaticValueService
} from "../../shared/services/static-value.service";
import {
  MobileNavService
} from "../../shared/services/mobile-nav.service";
import {
  DownloadService
} from "../../shared/services/html-png/html-png.service";
import {
  NotificationService
} from "../../shared/services/notification.service";
import {
  ProductService
} from "../../shared/services/product.service";
import {
  ShareReportPopupComponent
} from "../../shared/components/share-report-popup/share-report-popup.component";
import {
  MatDialog,
} from "@angular/material";
import {
  ToastService
} from "../../shared/services/toast.service";
import {
  AuthService
} from "../../shared/services/auth/auth.service";
import {
  PopupComponent
} from "./popup/popup.component";
import {
  FormControl
} from '@angular/forms';
import {
  BehaviorSubject,
  ReplaySubject,
  Subject
} from 'rxjs';
import {
  debounceTime,
  take,
  takeUntil
} from 'rxjs/operators';
import {
  MatSelect
} from '@angular/material/select';
import {
  CdkVirtualScrollViewport,
  VIRTUAL_SCROLL_STRATEGY,
  VirtualScrollStrategy,

} from '@angular/cdk-experimental/scrolling';

import { ListRange } from '@angular/cdk/collections';
import { remove, findIndex, cloneDeep} from 'lodash';


@Component({
  selector: "app-report-center",
  templateUrl: "./report-center.component.html",
  styleUrls: ["./report-center.component.scss"],
})
export class ReportCenterComponent implements OnInit, AfterViewInit, OnDestroy {
  public staticDDlist: any;
  isFileProcessing = false;
  isProcessing = false;
  supplierLoader = false;
  countryLoader = false;
  public tabs = "products";
  public totalProducts = 0;
  public totalBrands = 0;
  public totalSuppliers = 0;
  public totalCategories = 0;
  public totalUniqueProducts = 0;

  public searchNameBeh = new BehaviorSubject<string>('');
  public searchNameObs = this.searchNameBeh.asObservable();
  public obserablesArr = [];


  public supplierProdCatsChart: any = {};
  public prodsBySupplierChart: any = {};
  public prodsByCountryChart: any = {};
  public suppliersProductsAnalysisChart: any = {};
  public productsAnalysisChart: any = {};

  public supplierList = [];
  public brandsList = [];
  public manufacturerList = [];
  public countriesList = [];
  public search: any;
  public query: any = {};
  public dataQualityFlag: boolean = false;
  protected filteredColumnsCache: any[] = [];
  temManufacturere = [];
  temBrands = [];
  temCountries = [];
  public checkedAllBrand: boolean = true;

  temArray: any;

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  /** control for the selected bank for multi-selection */
  public productsMultiColumnsCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public productsMultiColumnsFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredProductsColumnsList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  initialRange: ListRange = { start: 0, end: 50 } as ListRange;
  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;


  public selectedValues = ['Product Name', 'Supplier', 'GTIN', 'Manufacturer', 'Short Tech Desc', 'Brand', 'Web Link', 'Warranty Desc', 'Website Country', 'Warranty URL', 'Primary Product Image', 'Secondary Product Image', 'Brand Logo', 'Price'];

  public supplierSelectedValues = ['GTIN', 'Manufacturer', 'Brand', 'Website Country', 'Primary Product Image'];

  public columnDataOptions = [
    {
      db: "basicInfo.prodName",
      name: 'Product Name',
      selected: true
    },
    {
      db: "categories.sparePartProds",
      name: 'Spare Part Products',
      selected: true
    },
    {
      db: "categories.accessoryProds",
      name: 'Accessory Products',
      selected: true
    },
    {
      db: "categories.kitProds",
      name: 'Kit Products',
      selected: true
    },
    {
      db: "categories.replacementProds",
      name: 'Replacement Products',
      selected: true
    },
    {
      db: "categories.upsellProds",
      name: 'Upsell/Cross Sell Products',
      selected: true
    },
    {
      db: "categories.equivProds",
      name: 'Equivalent Products',
      selected: true
    },
    {
      db: "categories.similarProds",
      name: 'Similar Products',
      selected: true
    },
    {
      db: "basicInfo.supplier.supplierName",
      name: 'Supplier',
      selected: true
    }, {
      db: "basicInfo.manufacturer.manufacturerName",
      name: 'Manufacturer',
      selected: true
    }, {
      db: "basicInfo.brand.brandName",
      name: 'Brand',
      selected: true
    }, {
      db: "basicInfo.webLink",
      name: 'Web Link',
      selected: false
    }, {
      db: "basicInfo.shortTechDesc",
      name: 'Short Tech Desc',
      selected: false
    }, {
      db: "basicInfo.extendTechDesc",
      name: 'Extended Tech Desc',
      selected: false
    }, {
      db: "basicInfo.warrantyDesc",
      name: 'Warranty Desc',
      selected: false
    }, {
      db: "basicInfo.warrantyUrl",
      name: 'Warranty URL',
      selected: false
    }, {
      db: "basicInfo.newItem",
      name: 'Is New Item',
      selected: false
    }, {
      db: "basicInfo.toBeDiscontinued",
      name: 'To Be Discontinued',
      selected: false
    }, {
      db: "basicInfo.countryOfOrigin",
      name: 'Website Country',
      selected: false
    }, {
      db: "basicInfo.dangerousGoods",
      name: 'Dangerous Goods',
      selected: false
    },
    {
      db: "basicInfo.price",
      name: 'Price',
      selected: false
    }, {
      db: "basicInfo.selectedForWebshop",
      name: 'Selected For Webshop',
      selected: false
    }, {
      db: "basicInfo.gtin",
      name: 'GTIN',
      selected: false
    }, {
      db: "basicInfo.supplierProdCat",
      name: 'Supplier Product Category',
      selected: false
    }, {
      db: "basicInfo.unspsc",
      name: 'UNSPSC',
      selected: false
    }, {
      db: "basicInfo.addPartNum",
      name: 'Additional Part Number',
      selected: false
    },
    {
      db: "basicInfo.distributorPartNum",
      name: 'Distributor Part Number',
      selected: false
    },
    {
      db: "created_at",
      name: 'Date Scrapped',
      selected: false
    },
    {
      db: "misc.metaTitle",
      name: 'Meta Title',
      selected: false
    }, {
      db: "misc.metaKeywords",
      name: 'Meta Keywords',
      selected: false
    }, {
      db: "misc.metaDesc",
      name: 'Meta Description',
      selected: false
    }, {
      db: "packagingInfo.packType",
      name: 'Pack Type',
      selected: false
    }, {
      db: "packagingInfo.packGtin",
      name: 'Pack GTIN',
      selected: false
    },
    {
      db: "packagingInfo.totalUnits",
      name: 'Total Units',
      selected: false
    },
    {
      db: "packagingInfo.lowestLevelUOM",
      name: 'Lowest Level UOM',
      selected: false
    },
    {
      db: "packagingInfo.numSubPacks",
      name: 'Number Sub Packs',
      selected: false
    },
    {
      db: "packagingInfo.packDesc",
      name: 'Pack Desc',
      selected: false
    },
    {
      db: "packagingInfo.itemsList",
      name: 'Items List',
      selected: false
    },
    {
      db: "packagingInfo.subPackGtin",
      name: 'Sub Pack Gtin',
      selected: false
    },
    {
      db: "categories.prodSeriresWebLink",
      name: 'Product Series Weblink',
      selected: false
    }, {
      db: "categories.googleProdCat",
      name: 'Google Product Category',
      selected: false
    }, {
      db: "categories.prodSeriesName",
      name: 'Product Series Name',
      selected: false
    }, {
      db: "categories.etimClassCode",
      name: 'ETIM Class Code',
      selected: false
    }, {
      db: "categories.etimVerNum",
      name: 'ETIM Version Number',
      selected: false
    }, {
      db: "categories.etimAttr",
      name: 'ETIM Attribute',
      selected: false
    },
    {
      db: "documents.conformityStatement",
      name: 'Conformity Statement',
      selected: false
    },
    {
      db: 'documents.rohsCompliant',
      name: 'Rohs Compliant',
    },
    {
      db: 'documents.brochureUrl',
      name: 'Brochure Url',
    },
    {
      db: 'documents.complianceCertUrl',
      name: 'Compliance Cert Url',
    },
    {
      db: 'documents.installInstructionsUrl',
      name: 'Install Instructions Url'
    },

    {
      db: "documents.safetyDataSheetUrl",
      name: 'Safety Data Sheet Url'
    },
    {
      db: "documents.userManualUrl",
      name: 'User Manual Url'
    },
    {
      db: 'documents.techDataSheetUrl',
      name: 'Tech DataSheet Url'
    },
    {
      db: 'measures.grossHeightUom',
      name: 'Gross Height Uom',
    },
    {
      db: 'measures.weight',
      name: 'Weight',
    },
    {
      db: 'measures.height',
      name: 'Height',
    },
    {
      db: 'measures.weightUom',
      name: 'Weight Uom',
    },
    {
      db: 'measures.heightUom',
      name: 'Height Uom',
    },
    {
      db: 'measures.volumeUom',
      name: 'Volume Uom',
    },
    {
      db: 'measures.grossWeightUom',
      name: 'Gross Weight Uom',
    },
    {
      db: 'measures.grossVolume',
      name: 'Gross Volume',
    },
    {
      db: 'measures.width',
      name: 'width',
    },
    {
      db: 'measures.grossWidth',
      name: 'Gross Width',
    },
    {
      db: 'measures.widthUom',
      name: 'Width Uom',
    },
    {
      db: 'measures.grossLength',
      name: 'Gross Length',
    },
    {
      db: 'measures.grossHeight',
      name: 'Gross Height',
    },
    {
      db: 'measures.Volume',
      name: 'Gross Volume',
    },
    {
      db: 'measures.grossLengthUom',
      name: 'Gross Length Uom',
    },
    {
      db: 'measures.grossWeight',
      name: 'Gross Weight',
    },
    {
      db: 'measures.grossWidthUom',
      name: 'Gross Width Uom',
    },
    {
      db: 'measures.grossVolumeUom',
      name: 'Gross Volume Uom',
    },
    {
      db: 'measures.heightUom',
      name: 'Height Uom',
    },
    {
      db: 'measures.length',
      name: 'Length',
    },
    {
      db: 'measures.lengthUom',
      name: 'Length Uom'
    }
  ];



  constructor(
    public staticDataService: StaticValueService,
    public mobileNav: MobileNavService,
    public htmlPngService: DownloadService,
    public notificationService: NotificationService,
    public dialog: MatDialog,
    public toastService: ToastService,
    public authService: AuthService,
    public productServiceObj: ProductService
  ) {
    this.hideMobileNav();
    this.staticDDlist = this.staticDataService.staticData.staticDD;
  }

  @ViewChild('multiSelectSupplier') multiSelectSupplier: MatSelect;
  @ViewChild('multiSelectManufacturer') multiSelectManufacturer: MatSelect;
  @ViewChild('multiSelectBrand') multiSelectBrand: MatSelect;
  @ViewChild('multiSelectCountries') multiSelectCountries: MatSelect;
  @ViewChild('multiSelectProductsColumns') multiSelectProductsColumns: MatSelect;


  tabChange(val: any) {
    this.tabs = val;
    if (val === "dataQualityAnalysis") {
      this.dataQualityFlag = true;
      this.getProductsDataAnalysis();
    } else {
      this.dataQualityFlag = false;
      this.getProductsData();
      this.getSupplierGraphDta();
      this.getProdCatsGraphData();
      this.getCountryGraphData();
    }
  }

  // swipe for mobile
  swipeTabs(event) {
    if (window.innerWidth < 768) {
      let tabsArray = [];
      let indexLimit = 3;
      tabsArray = ["associates", "companies", "sites"];
      indexLimit = 2;
      let currIndex = tabsArray.indexOf(this.tabs);
      if (event === "swipeleft") {
        currIndex = currIndex + 1;
      } else if (event === "swiperight") {
        currIndex = currIndex - 1;
      }
      if (currIndex < 0) {
        currIndex = 0;
      } else if (currIndex > indexLimit) {
        currIndex = indexLimit;
      }
      this.tabChange(tabsArray[currIndex]);
      const list = document.getElementById("tabsUl"),
        targetLi = document.getElementById(tabsArray[currIndex]);
      list.scrollLeft = targetLi.offsetLeft - 50;
    }
  }

  ngOnInit() {
    this.columnDataOptions.sort(function (a, b) {
      let dateA = a.name.toLowerCase();
      let dateB = b.name.toLowerCase();
      if (dateA < dateB) {
        return -1;
      }
      else if (dateA > dateB) {
        return 1;
      }
      return 0;
    });
    // // set initial selection
    // this.productsMultiColumnsCtrl.setValue(this.selectedValues);

    // console.log(this.columnDataOptions);

    // // load the initial brands list
    // this.filteredProductsColumnsList.next(this.columnDataOptions.slice());
    this.filteredProductsColumnsList.next(this.columnDataOptions);
    // listen for search field value changes
    this.productsMultiColumnsFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProductColumnsList();
      });

    // listen for multi select field value changes
    // this.productsMultiColumnsCtrl.valueChanges
    //   .pipe(takeUntil(this._onDestroy)).subscribe(() => {

    //   });

    this.query = {
      search: {
        // 'isArchived': false
      },
    };
    if (sessionStorage.getItem('productSearch')) {
      this.search = JSON.parse(sessionStorage.getItem('productSearch'));
    } else {
      this.search = {
        name: '',
        // isArchived: false
      };
    }
    this.search['suppliers'] = ['all'];
    this.search['brands'] = ['all'];
    this.search['manufacturers'] = ['all'];
    this.search['countries'] = ['all'];
    // this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
    //   this.onChange('');
    // }));
    // this.getProductsData();
    // this.getListFilterValues();
    this.getListFilterValuesnew();
    // this.getProdCatsGraphData();

  }


  ngOnDestroy() {
    this.obserablesArr.forEach(element => {
      element.unsubscribe();
    });
  }
  ngAfterViewInit() {
    this.setInitialValue();
  }
  scrolledIndexChange($event) {
    if (!this.initialRange) {
      this.initialRange = this.cdkVirtualScrollViewport.getRenderedRange();
    }
  }

  /** control for the selected bank for multi-selection */
  public supplierMultiCtrl: FormControl = new FormControl([]);
  public manufacturerMultiCtrl: FormControl = new FormControl([]);
  public brandMultiCtrl: FormControl = new FormControl([]);
  public countriesMultiCtrl: FormControl = new FormControl([]);

  /** control for the MatSelect filter keyword multi-selection */
  public supplierMultiFilterCtrl: FormControl = new FormControl();
  public manufacturerMultiFilterCtrl: FormControl = new FormControl();
  public brandMultiFilterCtrl: FormControl = new FormControl();
  public countriesMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredSupplierList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredManufacturerList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredBrandList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredCountriesList: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);


  public tooltipMessage = 'Select All / Unselect All';
  protected _onDestroy = new Subject<void>();


  toggleSelectAll(selectAllValue: boolean, arrayName) {
    if (arrayName == 'manufacturer') {
      this.filteredManufacturerList
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe((val) => {
          if (selectAllValue) {
            this.manufacturerMultiCtrl.patchValue(val);
          } else {
            this.manufacturerMultiCtrl.patchValue([]);
          }
        });
      this.onChange(arrayName);
    } else if (arrayName == 'supplier') {
      this.filteredSupplierList
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe((val) => {
          if (selectAllValue) {
            this.supplierMultiCtrl.patchValue(val);
          } else {
            this.supplierMultiCtrl.patchValue([]);
          }
        });
      this.onChange(arrayName);
    } else if (arrayName == 'brand') {
      if (selectAllValue) {
        this.checkedAllBrand = selectAllValue;
        this.filteredBrandList.next(this.brandsList)
        this.temBrands = cloneDeep(this.brandsList);
      }
      this.filteredBrandList
        .pipe(take(1), takeUntil(this._onDestroy))
        .subscribe((val) => {
          if (selectAllValue) {
            // this.filteredBrandList.next(this.brandsList)
            this.brandMultiCtrl.patchValue(val);

          } else {
            this.checkedAllBrand = selectAllValue;
            this.brandMultiCtrl.patchValue([]);
          }
        });
      
      // if (!selectAllValue) {
      //   this.checkedAllBrand = selectAllValue;
      //   this.brandMultiCtrl.setValue([]);
      // } else {
      //   this.checkedAllBrand = selectAllValue;
      //   this.filteredBrandList.next(this.brandsList)
      //   this.filteredBrandList.subscribe(data => {
      //     this.brandMultiCtrl.setValue(data);
      //   })
      //   this.temBrands = cloneDeep(this.brandsList);

      // }
      this.onChange(arrayName);
    } else if (arrayName == 'country') {
      if (!selectAllValue) {
        this.countriesMultiCtrl.setValue([])
      } else {
        this.filteredCountriesList.subscribe(data => {
          this.countriesMultiCtrl.setValue(data);
        })
      }
      this.onChange(arrayName);
    }
    else {
      this.onChange(arrayName);
    }

  }


  selectedColumns() {
    this.selectedValues = [];
    this.productsMultiColumnsCtrl.value.forEach(ele => {
      this.selectedValues.push(ele.name)
    });
    this.productsMultiColumnsCtrl.setValue(this.selectedValues);
    this.onChange('');
  }

  onChange(flag) {
    let query = {
      // isArchived: this.search.isArchived
    };

    query["brandName"] = {
      $in: this.brandMultiCtrl.value
    }
    query["manufacturerName"] = {
      $in: this.manufacturerMultiCtrl.value
    }
    query["supplierName"] = {
      $in: this.supplierMultiCtrl.value
    }

    let newSearch = {
      countries: this.countriesList,
      suppliers: this.supplierMultiCtrl.value
    };

    let fieldsToGet = [];
    let suppliersFieldsToGet = [];

    this.columnDataOptions.forEach(opt => {
      if (this.selectedValues.includes(opt.name)) {
        fieldsToGet.push(opt)
      }
    });
    // this.columnDataOptions.forEach(vl => {
    //   if (this.supplierSelectedValues.includes(vl.name)) {
    //     suppliersFieldsToGet.push(vl)
    //   }
    // })

    this.query.search = Object.assign({}, query);
    // this.query['fieldsToGet'] = fieldsToGet;
    this.query['fieldsToGet'] = ['Supplier', 'Manufacturer', 'Brand', 'GTIN', 'Weblink', 'Price', 'Long Desc', 'Gross Weight', 'Short Tech Desc', 'Product Name', 'Datasheet']
    this.query['suppliersFieldsToGet'] = suppliersFieldsToGet;

    this.temManufacturere = this.manufacturerMultiCtrl.value;
    // this.temBrands = this.brandMultiCtrl.value;
    this.temCountries = this.countriesMultiCtrl.value;
    if (this.manufacturerMultiCtrl.value.length >= 0 && flag == 'manufacturer') {
      if (this.manufacturerMultiCtrl.value.length == 0) {
        this.brandMultiCtrl.setValue([]);
      }
      newSearch['manufacturers'] = this.manufacturerMultiCtrl.value;
      this.productServiceObj.productsFiltersData(newSearch).subscribe(
        (data: any) => {
          if (data && data.length > 0) {
            const sortData = this.sortFilterData(data[0]);
            this.brandMultiCtrl.setValue(sortData.brand);
            this.filteredBrandList.next(sortData.brand);
            this.brandsList = cloneDeep(sortData.brand);
            this.temBrands = cloneDeep(sortData.brand);
            this.temArray = sortData.brand.length
            this.query.search["brandName"].$in = this.brandMultiCtrl.value;
            this.query.search["manufacturerName"].$in = this.manufacturerMultiCtrl.value;
            this.query.search["supplierName"].$in = this.supplierMultiCtrl.value;            // this.getProductsFromService();
            if (this.dataQualityFlag) {
              this.getProductsData();
              this.getProductsDataAnalysis();
            } else {
              this.getProductsData();
              this.getSupplierGraphDta();
              this.getProdCatsGraphData();
              this.getCountryGraphData();

            }
          } else if (data.length == 0) {
            this.brandMultiCtrl.setValue([]);
            this.filteredBrandList.next([]);
            this.query.search["brandName"].$in = this.brandMultiCtrl.value;
            // this.getProductsFromService();
            if (this.dataQualityFlag) {
              this.getProductsData();
              this.getProductsDataAnalysis();
            } else {
              this.getProductsData();
              this.getSupplierGraphDta();
              this.getProdCatsGraphData();
              this.getCountryGraphData();

            }
          }
        },
        (err) => {
          console.log("============== ", err)
        }
      )
    } else if (this.supplierMultiCtrl.value && flag == 'supplier') {
      if (this.supplierMultiCtrl.value.length == 0) {
        this.brandMultiCtrl.setValue([]);
      }
      newSearch['suppliers'] = this.supplierMultiCtrl.value;
      this.productServiceObj.productsFiltersData(newSearch).subscribe(
        (data: any) => {
          if (data && data.length > 0) {
            // this.manufacturerMultiCtrl.setValue(data[0].manufacturer);
            const sortData = this.sortFilterData(data[0]);
            this.manufacturerMultiCtrl.setValue(sortData.manufacturer);
            this.brandMultiCtrl.setValue(sortData.brand);
            this.filteredManufacturerList.next(sortData.manufacturer);
            this.filteredBrandList.next(sortData.brand);
            this.brandsList = cloneDeep(sortData.brand);
            this.temBrands = cloneDeep(sortData.brand);
            this.temArray = sortData.brand.length
            this.query.search["brandName"].$in = this.brandMultiCtrl.value;
            this.query.search["manufacturerName"].$in = this.manufacturerMultiCtrl.value;
            this.query.search["supplierName"].$in = this.supplierMultiCtrl.value;

            // this.query.search["basicInfo.supplier.supplierName"].$in = this.supplierMultiCtrl.value;
            // this.getProductsFromService();
            this.getCountriesList(newSearch.suppliers);
            if (this.dataQualityFlag) {
              this.getProductsData();
              this.getProductsDataAnalysis();
            } else {
              this.getProductsData();
              this.getSupplierGraphDta();
              this.getProdCatsGraphData();
              this.getCountryGraphData();

            }

          }
          // else if (data.length == 0 && this.filteredManufacturerList)  {
          //   console.log(" this is data ", data)

          //   this.brandMultiCtrl.setValue([]);
          //   this.filteredBrandList.next([]);
          //   this.query.search["basicInfo.brand.brandName"].$in = this.brandMultiCtrl.value;
          //   this.getProductsFromService();
          // }
          else {
            this.filteredManufacturerList.next([]);
            this.filteredBrandList.next([]);
            this.query.search["brandName"].$in = [];
            // this.getProductsFromService();
            if (this.dataQualityFlag) {
              this.getProductsData();
              this.getProductsDataAnalysis();
            } else {
              this.getProductsData();
              this.getSupplierGraphDta();
              this.getProdCatsGraphData();
              this.getCountryGraphData();

            }
          }

        },

        (err) => {
          console.log("============== ", err)
        }
      )
    } else if (this.brandMultiCtrl.value && flag == 'brand') {
      if (!this.checkedAllBrand && this.brandMultiCtrl.value && this.brandMultiCtrl.value > 0) {
        this.filteredBrandList.next(this.brandMultiCtrl.value);
        this.brandMultiCtrl.setValue(this.brandMultiCtrl.value);
      }
      if (this.checkedAllBrand && this.brandMultiCtrl.value && this.brandMultiCtrl.value.length > 0) {
        this.filteredBrandList.next(this.brandsList);
        this.brandMultiCtrl.setValue(this.temBrands);
      }
      this.temArray = this.brandMultiCtrl.value.length;

      this.query.search["brandName"].$in = this.brandMultiCtrl.value;
      this.query.search["manufacturerName"].$in = this.manufacturerMultiCtrl.value;
      this.query.search["supplierName"].$in = this.supplierMultiCtrl.value;
      if (this.dataQualityFlag) {
        this.getProductsData();
        this.getProductsDataAnalysis();
      } else {
        this.getProductsData();
        this.getSupplierGraphDta();
        this.getProdCatsGraphData();
        this.getCountryGraphData();

      }
    }
    else if (this.countriesMultiCtrl.value && flag == 'country') {
      if (this.countriesMultiCtrl.value.length == 0) {
        this.countriesMultiCtrl.setValue([]);
        this.query.search["countryOfOrigin"] = {
          $in: []
        }
        // this.getProductsFromService();
        if (this.dataQualityFlag) {
          this.getProductsData();
          this.getProductsDataAnalysis();
        } else {
          this.getProductsData();
          this.getSupplierGraphDta();
          this.getProdCatsGraphData();
          this.getCountryGraphData();

        }

      } else {
        this.query.search["brandName"].$in = this.brandMultiCtrl.value;
        this.query.search["manufacturerName"].$in = this.manufacturerMultiCtrl.value;
        this.query.search["supplierName"].$in = this.supplierMultiCtrl.value;
        this.query.search["countryOfOrigin"] = {
          $in: this.countriesMultiCtrl.value
        }
        // this.getProductsFromService();
        if (this.dataQualityFlag) {
          this.getProductsData();
          this.getProductsDataAnalysis();
        } else {
          this.getProductsData();
          this.getSupplierGraphDta();
          this.getProdCatsGraphData();
          this.getCountryGraphData();

        }
      }
    } else {
      if (this.dataQualityFlag) {
        this.getProductsData();
        this.getProductsDataAnalysis();
      } else {
        this.getProductsData();
        this.getSupplierGraphDta();
        this.getProdCatsGraphData();
        this.getCountryGraphData();
      }
    }
  }



  // get filters data

  getListFilterValuesnew() {
    this.productServiceObj.getListFilterValues().then(resp => {
      resp['suppliers'].sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      resp['manufacturers'].sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
      resp['brands'].sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });

      // resp['suppliers'].length = 10;
      this.supplierList = resp['suppliers'];
      this.supplierMultiCtrl.setValue(resp['suppliers']);

      this.manufacturerList = resp['manufacturers'];
      this.manufacturerMultiCtrl.setValue(resp['manufacturers']);

      this.brandsList = resp['brands'];
      this.brandMultiCtrl.setValue(resp['brands']);

      // load the initial bank list
      this.filteredSupplierList.next(this.supplierList.slice());

      // load the initial manufacturer list
      this.filteredManufacturerList.next(this.manufacturerList.slice());

      // load the initial brands list
      this.filteredBrandList.next(this.brandsList.slice());
      // listen for search field value changes
      this.supplierMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterBanksMulti();
        });
      this.manufacturerMultiFilterCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterManufacturer();
        })
      this.brandMultiFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
        this.filterBrandList();
      })

      this.search['suppliers'] = this.search['suppliers'].concat(this.supplierList);
      this.search['manufacturers'] = this.search['manufacturers'].concat(this.manufacturerList);
      // this.search['brands'] = this.search['brands'].concat(this.brandsList);
      // this.search['countries'] = this.search['countries'].concat(this.countriesList);
      let customSearch = this.search;
      delete customSearch.manufacturers;
      // delete customSearch.brands;
      // delete customSearch.brand;
      if (customSearch.suppliers.length > 0) {
        return this.productServiceObj.productsFiltersData(customSearch).subscribe(
          (data: any) => {
            if (data && data.length > 0) {
              const sortData = this.sortFilterData(data[0]);

              this.filteredManufacturerList.next(sortData.manufacturer);
              this.filteredBrandList.next(sortData.brand);
              this.brandsList = sortData.brand;
              this.manufacturerList = sortData.manufacturer
              this.manufacturerMultiCtrl.setValue(sortData.manufacturer);
              this.brandMultiCtrl.setValue(sortData.brand);
              this.temBrands = cloneDeep(sortData.brand);
              this.brandsList = cloneDeep(sortData.brand);
              this.temArray = sortData.brand.length;
              // this.search.manufacturers = data[0].manufacturer;
              // this.search.brands = data[0].brand;

            } else {
              this.filteredManufacturerList.next([]);
              this.filteredBrandList.next([]);
            }
            this.getCountriesList(this.supplierList);
            this.obserablesArr.push(this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
              this.onChange('');
            }));
          },
          (err) => {
            console.log("============== ", err)
          }
        )
      }
    }).catch(err => {
      console.log(err);
    });
  }
  // get country list
  getCountriesList(data) {
    return this.productServiceObj.getCountries(data).subscribe(
      (data) => {
        data['country'].sort(function (a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        });
        this.countriesList = data['country'];
        this.countriesMultiCtrl.setValue(data['country']);

        this.filteredCountriesList.next(data['country']);

        this.countriesMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterCountriesList();
          })
        this.search['countries'] = this.search['countries'].concat(this.countriesList);
      },
      (err) => {
        console.log(" error while fetching countries ", err)
      }
    )
  }


  productData = [];
  countriesData = [];

  getProductsData() {
    this.drawSupplierProdCatsChart([], []);
    this.drawProdsByCountryChart([]);
    this.drawSupplierProdCatsChart2([], []);
    this.supplierLoader = true;
    this.productServiceObj.getReportingHubData(this.query.search)
      .subscribe(
        (resp) => {
          this.supplierLoader = false;
          if (resp) {
            //   resp["totalProds"][0]["total"])
            if (resp["totalProds"] && resp["totalProds"].length > 0 ) {
              this.totalProducts = resp["totalProds"][0]["total"];
            } else if (resp["totalProds"].length === 0) {
              this.totalProducts = 0;
            }
            if (
              resp["isUniqueTotal"] &&
              resp["isUniqueTotal"][0] &&
              resp["isUniqueTotal"][0]["total"]
            ) {
              this.totalUniqueProducts = resp["isUniqueTotal"][0]["total"];
            } else if (resp["isUniqueTotal"].length === 0) {
              this.totalUniqueProducts = 0;
            }

            if (
              resp["totalSupp"] &&
              resp["totalSupp"][0] &&
              resp["totalSupp"][0]["total"]
            ) {
              this.totalSuppliers = resp["totalSupp"][0]["total"];
            } else if (resp["totalSupp"].length === 0) {
              this.totalSuppliers = 0;
            }
            if (
              resp["totalCats"] &&
              resp["totalCats"][0] &&
              resp["totalCats"][0]["total"]
            ) {
              this.totalCategories = resp["totalCats"][0]["total"];
            } else if (resp["totalCats"].length === 0) {
              this.totalCategories = 0;
            }

            if (
              resp["totalBrands"] &&
              resp["totalBrands"][0] &&
              resp["totalBrands"][0]["total"]
            ) {
              this.totalBrands = resp["totalBrands"][0]["total"];
            } else if (resp["totalBrands"].length === 0) {
              this.totalBrands = 0;
            }
            // if (resp["prodCatsGraph"] && resp["prodCatsGraph"].length) {
            //   let cats = [];
            //   let data = [];
            //   resp["prodCatsGraph"].forEach((indCat) => {
            //     cats.push(indCat._id);
            //     data.push(parseInt(indCat.total));
            //   });
            //   this.drawSupplierProdCatsChart(cats, data);
            // }
            // if (resp["suppliersGraph"] && resp["suppliersGraph"].length) {
            //   let data = [];
            //   resp["suppliersGraph"].forEach((indSup) => {
            //     data.push({
            //       name: indSup._id ? indSup._id : "N/A",
            //       y: parseInt(indSup.total),
            //     });
            //   });
            //   this.productData = data;
            //   this.drawProdsBySupplierChart(data);
            // }
            // if (resp["countryGraph"] && resp["countryGraph"].length) {
            //   let data = [];
            //   resp["countryGraph"].forEach((indSup) => {
            //     data.push({
            //       name: indSup._id ? indSup._id : "N/A",
            //       y: parseInt(indSup.total),
            //     });
            //   });
            //   this.drawProdsByCountryChart(data);
            // }
          }
        }, (err) => {
          this.supplierLoader = false;
          console.log(err);
        }
      )
    // .catch((err) => {

    // });
  }

  // get supplier graph 
  getSupplierGraphDta() {
    this.supplierLoader = true;
    this.productServiceObj.supplierGraphData(this.query.search).subscribe(
      (supplier: any) => {
        this.supplierLoader = false;

        if (supplier && this.supplierList.length > 0) {
          let data = [];
          supplier.forEach((indSup) => {
            data.push({
              name: indSup._id ? indSup._id : "N/A",
              y: parseInt(indSup.total),
            });
          });
          this.productData = data;
          this.drawProdsBySupplierChart(data);
        }
      },
      (err) => {
        this.supplierLoader = false;
      }
    )
  }
  // product categories  chart 
  getProdCatsGraphData() {
    this.isProcessing = true;
    this.productServiceObj.prodCatsGraphData(this.query.search).subscribe(
      (val: any) => {
        this.isProcessing = false;

        if (val && val.length > 0) {
          let cats = [];
          let data = [];
          val.forEach((indCat) => {
            cats.push(indCat._id);
            data.push(parseInt(indCat.total));
          });
          this.drawSupplierProdCatsChart(cats, data);
        }
      }, (err) => {
        this.isProcessing = false;
        console.log(" =========== ", err)
      }
    )
  }

  getCountryGraphData() {
    this.countryLoader = true;
    this.productServiceObj.countryGraphData(this.query.search).subscribe(
      (val: any) => {
        this.countryLoader = false;
        if (val && val.length > 0) {
          let data = [];
          val.forEach((indSup) => {
            data.push({
              name: indSup._id ? indSup._id : "N/A",
              y: parseInt(indSup.total),
            });
          });
          this.drawProdsByCountryChart(data);
        }
      },
      (err) => {
        this.countryLoader = false;
        console.log(" this is err", err)
      }
    )
  }
  // get products data
  getProductsDataAnalysis() {
    this.isFileProcessing = true;
    this.productServiceObj.getProductsDataAnalysis(this.query.fieldsToGet, this.query.search).subscribe(
      (data) => {
        this.isFileProcessing = false;
        let cats = [];
        let values = [];
        data['data'].forEach(ele => {
          ele.forEach(val => {
            cats.push(val._id);
            values.push(parseInt(val.Count));

          });
        });
        this.drawSupplierProdCatsChart2(cats, values);
      },
      (err) => {
        this.isFileProcessing = false;
        console.log(" errr ++", err)
      }

    )
  }

  // suppliers chart data
  // getSuppliersProductsData() {
  //   this.isFileProcessing = true;
  //   this.ProductServiceObj.getSuppliersDataAnalysis(this.query.suppliersFieldsToGet, this.query.search).subscribe(
  //     (data) => {
  //       console.log("  this is data  +++ ", data)
  //     }, (error) => {
  //       this.isFileProcessing = false;
  //       console.log(" errr ++", error)
  //     }
  //   )
  //   this.drawSupplierAnalysisChart();

  // }

  drawProdsByCountryChart(data) {
    this.countriesData = data;
    this.prodsByCountryChart = new Chart({
      chart: {
        type: "pie",
        height: 298,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          },
          showInLegend: true
        }
      },
      series: [{
        name: "No of Products",
        data: data,
        innerSize: "80%",
      },],
    });
  }

  drawProdsBySupplierChart(data) {
    this.prodsBySupplierChart = new Chart({
      chart: {
        type: "pie",
        height: 298,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: true,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
          },
          showInLegend: true
        }
      },
      series: [{
        name: "No of Products",
        data: data,
        innerSize: "80%",
      },],
    });
  }
  supplierProdCat = [];
  drawSupplierProdCatsChart(cats, data) {
    cats.forEach((element, i) => {
      this.supplierProdCat.push({
        name: element,
        y: data[i]
      })
    });
    this.supplierProdCatsChart = new Chart({
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: cats,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Product in Category",
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      series: [{
        name: "Products Count",
        data: data,
      },],
    });
  }
  drawSupplierProdCatsChart2(cats, data) {
    cats.forEach((element, i) => {
      this.supplierProdCat.push({
        name: element,
        y: data[i]
      })
    });
    this.productsAnalysisChart = new Chart({
      chart: {
        type: "column",
      },
      title: {
        text: "",
      },
      xAxis: {
        categories: cats,
        crosshair: true,
      },
      yAxis: {
        min: 0,
        title: {
          text: "Product in Category",
        },
      },
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
      },
      series: [{
        name: "Products Count",
        data: data,
      },],
    });
  }

  drawSupplierAnalysisChart() {
    this.suppliersProductsAnalysisChart = new Chart({

      chart: {
        type: 'column'
      },

      title: {
        text: 'Total Products Grouped by Suppliers'
      },

      xAxis: {
        categories: ['nomi ', 'shery', 'Ali', 'saleh', 'karar', 'xyz']
      },

      yAxis: {
        allowDecimals: false,
        min: 0,
        title: {
          text: 'Number of fruits'
        }
      },

      tooltip: {
        formatter: function () {
          return '<b>' + this.x + '</b><br/>' +
            this.series.name + ': ' + this.y + '<br/>' +
            'Total: ' + this.point.stackTotal;
        }
      },

      plotOptions: {
        column: {
          stacking: 'normal'
        }
      },

      series: [
        {
          name: 'gtin',
          data: [2, 3, 4, 7, 2],
          stack: 'gtin'
        }, {
          name: 'gtin null count',
          data: [0, 4, 4, 2, 5],
          stack: 'gtin'
        }, {
          name: 'Jane',
          data: [2, 5, 6, 2, 1],
          stack: 'female'
        }, {
          name: 'Janet',
          data: [3, 0, 4, 4, 3],
          stack: 'female'
        },
        {
          name: 'xyz',
          data: [2, 5, 6, 2, 1],
          stack: 'abc'
        }, {
          name: 'xyz',
          data: [3, 0, 4, 4, 3],
          stack: 'abc'
        }
      ]
    })
  }

  onClickMe() {
    this.mobileNav.showSideNav();
  }

  hideMobileNav() {
    this.mobileNav.hideSideNav();
  }

  pngDownload(chartName, elementId, data) {
    this.htmlPngService.downloadPng(chartName, elementId, this.supplierMultiCtrl.value, this.manufacturerMultiCtrl.value, data);
  }
  pngDownloadAll(chartName, elementId, bySupplier, byCountry, top20) {
    this.htmlPngService.downloadPngAll(chartName, elementId, this.supplierMultiCtrl.value, this.manufacturerMultiCtrl.value, bySupplier, byCountry, top20);
  }
  shareReport(chartName, elementId) {
    const dialogRef = this.dialog.open(ShareReportPopupComponent, {
      width: "500px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "Cancel") { } else {
        this.htmlPngService.shareReportInEmail(
          chartName,
          elementId,
          result["emailAddress"],
          this.authService.user.name
        );
      }
    });
  }

  openDialog(data, heading) {
    this.dialog.open(PopupComponent, {
      width: "600px",
      data: {
        val: data,
        title: heading
      },
    });
  }

  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    // this.filteredProductsColumnsList.pipe(take(1), takeUntil(this._onDestroy))
    //   .subscribe(() => {
    //     console.log("+++++", this.multiSelectProductsColumns);

    //     this.multiSelectProductsColumns.compareWith = (a: any, b: any) => {
    //       console.log(" check ++ ", a, '===', b)
    //       return a.name === b
    //     }
    //   })
    this.filteredSupplierList
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
      });
    this.filteredManufacturerList.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {

      });
    this.filteredBrandList.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {

      })
    this.filteredCountriesList.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {

      })

  }

  /**
   * Sets the initial value after the manufacturer List  are loaded initially
   */
  protected filterBanksMulti() {
    if (!this.supplierList) {
      return;
    }
    // get the search keyword
    let search = this.supplierMultiFilterCtrl.value;
    if (!search) {
      this.filteredSupplierList.next(this.supplierList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the supliers
    this.filteredSupplierList.next(
      this.supplierList.filter(bank => bank.toLowerCase().indexOf(search) > -1)
    );
  }
  protected filterManufacturer() {
    if (!this.manufacturerList) {
      return
    }
    let search = this.manufacturerMultiFilterCtrl.value;
    if (!search) {
      this.filteredManufacturerList.next(this.manufacturerList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the supliers
    this.filteredManufacturerList.next(
      this.manufacturerList.filter(m => m.toLowerCase().indexOf(search) > -1)
    );
  }
  protected filterBrandList() {
    if (!this.brandsList) {
      return;
    }
    let search = this.brandMultiFilterCtrl.value;
    if (!search) {
      this.filteredBrandList.next(this.brandsList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBrandList.next(
      this.brandsList.filter(b => b.toLowerCase().indexOf(search) > -1)
    )
  }
  protected filterCountriesList() {
    if (!this.countriesList) {
      return;
    }
    let search = this.countriesMultiFilterCtrl.value;
    if (!search) {
      this.filteredCountriesList.next(this.countriesList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredCountriesList.next(
      this.countriesList.filter(b => b.toLowerCase().indexOf(search) > -1)
    )
  }
  protected filterProductColumnsList() {
    if (!this.columnDataOptions) {
      return;
    }
    let search = this.productsMultiColumnsFilterCtrl.value;
    if (!search) {
      this.filteredColumnsCache = this.columnDataOptions.slice();
      this.filteredProductsColumnsList.next(this.filteredColumnsCache);
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredColumnsCache = this.columnDataOptions.filter(
      val => val.name.toLowerCase().indexOf(search) > -1
    );
    this.filteredProductsColumnsList.next(this.filteredColumnsCache);

  }

  // sort string array
  sortFilterData(val) {
    const data = {
      suppleir: val.supplier.sort(function (a, b) {

        return a.toLowerCase().localeCompare(b.toLowerCase());
      }),
      manufacturer: val.manufacturer.sort(function (a, b) {

        return a.toLowerCase().localeCompare(b.toLowerCase());
      }),
      brand: val.brand.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      })
    }
    return data;
  }

  triggerEvent(e, val) {
    if (!e && val == 'brand') {
      this.cdkVirtualScrollViewport.scrollToIndex(0);
      this.cdkVirtualScrollViewport.checkViewportSize()
    }
    if (this.supplierMultiCtrl.value && this.supplierMultiCtrl.value !== this.supplierList && val === 'supplier' && !e) {
      this.onChange(val)
    } else if (this.temManufacturere.length !== this.manufacturerMultiCtrl.value.length && this.manufacturerMultiCtrl.value.length >= 0 && val === 'manufacturer' && !e) {
      this.onChange(val);
    } else if (this.temCountries.length !== this.countriesMultiCtrl.value.length && this.countriesMultiCtrl.value.length >= 0 && val == 'country' && !e) {
      this.onChange(val);
    } else if (this.temArray != this.brandMultiCtrl.value.length && this.brandMultiCtrl.value.length >= 0 && val == 'brand' && !e) {
      this.onChange(val);
    }
  }

  onCheckboxChange(vl) {
    if (this.brandMultiCtrl.value.includes(vl)) {
      this.temBrands.push(vl)
      return;
    } else {
      let checkVal = this.temBrands.includes(vl);
      if (checkVal) {
        remove(this.temBrands, (c) => {
          return (c === vl); //remove 
        });
      }
      if (!this.checkedAllBrand && this.brandMultiCtrl.value && this.brandMultiCtrl.value > 0) {
        this.filteredBrandList.next(this.brandMultiCtrl.value);
        this.brandMultiCtrl.setValue(this.brandMultiCtrl.value);
      }
      if (this.checkedAllBrand) {
        this.filteredBrandList.next(this.brandsList);
        this.brandMultiCtrl.setValue(this.temBrands);
      }
    }

  }
}
